import { Action, createReducer, on } from '@ngrx/store';
import { IAVCFrequencyLookup } from '../models/pf-settings.model';
import * as actions from '../actions';

export const getAVCFrequencyLookupsFeatureKey = 'getAVCFrequencyLookups';

export interface AVCFrequencyLookupsState {
  loadAVCFrequencyLookupsResponse: IAVCFrequencyLookup[];
  loadAVCFrequencyLookupsFailure: any;
}

export const initialState: AVCFrequencyLookupsState = {
  loadAVCFrequencyLookupsResponse: undefined,
  loadAVCFrequencyLookupsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadAVCFrequencyLookups, (state, action) => ({
    ...state
  })),
  on(actions.loadAVCFrequencyLookupsSuccess, (state, action) => ({
    ...state,
    loadAVCFrequencyLookupsResponse: action.response
  })),
  on(actions.loadAVCFrequencyLookupsFailure, (state, action) => ({
    ...state,
    loadAVCFrequencyLookupsResponseFailure: action.error
  }))
);

export const getAVCFrequencyLookupsResponse = (state: AVCFrequencyLookupsState) => {
  if (state && state.loadAVCFrequencyLookupsResponse) return JSON.parse(JSON.stringify(state.loadAVCFrequencyLookupsResponse));
  else return null;
};
